export default "__VITE_ASSET__B1vdzW4y__"